import { ITasklistTask } from '@/api/tasklist';
import CustomIconBusinessProcess from '@/components/ui/CustomIconBusinessProcess';
import { FC } from 'react';
import { TimeAgo } from '@/components/shared/timeAgo/TimeAgo';

interface CardTask {
  onClick?: () => void;
  isActive?: boolean;
  task: ITasklistTask;
}

export const CardTask: FC<CardTask> = props => {
  return (
    <div
      data-testid="card"
      className={`border-2 transition ease-in-out duration-200 rounded-lg hover:cursor-pointer ${
        props.isActive && 'border-teal-500'
      }`}
      onClick={props.onClick}
      aria-hidden="true"
    >
      <div data-testid="card-content">
        <div className="flex px-4 py-2 items-center border-b space-x-2">
          <div
            className={`flex-none aspect-square p-1 rounded-[4px] ${props.isActive ? 'bg-teal-500' : 'bg-slate-400'}`}
          >
            <CustomIconBusinessProcess
              businessProcessKey={props.task.process_definition_id!}
              stroke={props.isActive ? '#14b8a6' : '#94a3b8'}
              size={16}
              fill="white"
            />
            {/* <BriefcaseBusiness  /> */}
          </div>
          <div
            className={`flex-1 line-clamp-1 text-ellipsis text-sm font-semibold ${!props.isActive && 'text-slate-500'}`}
          >
            {props.task.process_name ?? props.task.process_definition_id}
          </div>
        </div>
        <div className="px-4 py-3 items-center w-full m-0">
          <div className="flex flex-col gap-2">
            <span
              className={`text-sm font-semibold leading-4 line-clamp-2 text-ellipsis ${
                !props.isActive && 'text-slate-500'
              }`}
            >
              {props.task.name}
            </span>
            <div className="flex justify-between items-center w-full text-xs text-slate-500">
              <span className="w-full text-xs font-normal line-clamp-1 text-ellipsis text-slate-500 text-left mt-2">
                {props.task.assignee}
              </span>
              <span className="w-full text-xs font-normal line-clamp-1 text-ellipsis text-slate-500 text-right">
                {props.task.created_date ? <TimeAgo timestamp={props.task.created_date} /> : 'No date provided'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
